export default "__VITE_ASSET__ooeRPrcf__"